import React, {useState} from 'react';


import BubbleSpeechFriendly from 'svg-react-loader?name=Icon!../../../../public/images/inline/bubble-speech-friendly.svg';

import FeedbackForm from '../FeedbackForm';

import {ConfirmationButton} from '../../Button';
import {FormActions} from '../../Form';
import {I18nMessage} from '../../../contexts/I18n';
import {Modal} from '../../index';

import styles from './FeedbackButton.scss';


function FeedbackButton({}) {

    const [isOpen, setIsOpen] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);

    const doClose = () => {
        setIsOpen(false);
        setIsSubmitted(false);
    };

    return (
        <>
            <a
                aria-label={'Shows the feedback form'}
                className={styles.feedbackButton}
                href={'#'}
                onClick={() => setIsOpen(!isOpen)}
            >
                <BubbleSpeechFriendly/>
                <span>Improve Journexx</span>
            </a>

            {isOpen && (
                <Modal doClose={() => doClose()}>

                    <div className={styles.feedbackModal}>

                        {!isSubmitted && (
                            <>
                                <h2>
                                    <I18nMessage id={'feedback.title'}/>
                                </h2>
                                <p>
                                    <I18nMessage id={'feedback.text'}/>
                                </p>

                                <FeedbackForm onSubmitted={() => setIsSubmitted(true)}/>

                            </>
                        )}

                        {isSubmitted && (
                            <>
                                <h2>
                                    <I18nMessage id={'feedback.confirmation'}/>
                                </h2>

                                <FormActions>
                                    <ConfirmationButton
                                        labelI18n={'feedback.confirmation.button.close.label'}
                                        onClick={() => doClose()}
                                    />
                                </FormActions>
                            </>
                        )}
                    </div>

                </Modal>
            )}
        </>
    );
}


FeedbackButton.propTypes = {};

FeedbackButton.defaultProps = {};


export default FeedbackButton;
